module.exports = __webpack_public_path__ + "PeBN-nJUPb_WsGYCw/agent-training-center_about_our_leads.png";